/** Russian-locale number / time formatters. */

const RU_NUM = new Intl.NumberFormat("ru-RU");
const RU_DATE = new Intl.DateTimeFormat("ru-RU", { day: "numeric", month: "long", year: "numeric" });
const RU_TIME = new Intl.DateTimeFormat("ru-RU", { hour: "2-digit", minute: "2-digit" });
const RU_MONTHDAY = new Intl.DateTimeFormat("ru-RU", { day: "numeric", month: "long" });
const RU_SHORT = new Intl.DateTimeFormat("ru-RU", { day: "2-digit", month: "short" });

export function fmtNum(n: number | null | undefined): string {
  if (n === null || n === undefined) return "-";
  return RU_NUM.format(n);
}

export function fmtPct(n: number, digits = 1): string {
  return `${n.toFixed(digits)}%`;
}

export function fmtDate(d: string | Date): string {
  return RU_DATE.format(new Date(d));
}

export function fmtTime(d: string | Date): string {
  return RU_TIME.format(new Date(d));
}

export function fmtMonthDay(d: string | Date): string {
  return RU_MONTHDAY.format(new Date(d));
}

export function fmtShortDate(d: string | Date): string {
  return RU_SHORT.format(new Date(d));
}

export function fmtRelative(d: string | Date): string {
  const past = new Date(d).getTime();
  const diff = Date.now() - past;
  const m = Math.floor(diff / 60_000);
  if (m < 1) return "только что";
  if (m < 60) return `${m} мин назад`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} ч назад`;
  const days = Math.floor(h / 24);
  if (days < 7) return `${days} дн назад`;
  return RU_SHORT.format(new Date(d));
}
